import { useMemo } from "react";
import useQuery from "./useQuery";
import useDistinctShape from "@ui/lib/hooks/useDistinctShape";

/**
 * @description
 * ExternalGaps statusCodegnu
 * - 204 : cac/calculation in progress or no externalGaps
 */
export function useExternalGaps(projectId: string, analysisId: string) {
  const response = useQuery("/projects/:projectId(uuid)/analyses/:analysisId(uuid)/external-gaps", {
    routeParams: { projectId, analysisId },
    keepFresh: true,
  });

  return useMemo(() => (response.status === 204 ? null : response.body), [response]);
}

/** @description { [quantityId]: { [performanceIndicatorId]: { [analysisId]: number } } }*/
export const useMultipleExternalGaps = (projectId: string, analysisIds: string[]) => {
  const response = useQuery("/projects/:projectId(uuid)/analyses/external-gaps", {
    method: "POST",
    routeParams: { projectId },
    body: { analysisIds },
    keepPreviousData: true,
  });
  return useDistinctShape(response.body);
};
export type ExternalGaps = ReturnType<typeof useMultipleExternalGaps>;
